import { render, staticRenderFns } from "./SidebarExpenses.vue?vue&type=template&id=372fa9d4"
import script from "./SidebarExpenses.vue?vue&type=script&lang=js"
export * from "./SidebarExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports